import { BOOKING_BILLING_TYPE_AUTO, BOOKING_BILLING_TYPE_PAID, BOOKING_BILLING_TYPE_PRIVATE } from '../config/bookings'
import { hasBillingType } from '../utils'

const BILLING_TYPES_CHARGING_DRIVERS = [
  BOOKING_BILLING_TYPE_PAID,
  BOOKING_BILLING_TYPE_PRIVATE,
  BOOKING_BILLING_TYPE_AUTO,
]

export const canDriversPayForBookings = (billingTypes) =>
  BILLING_TYPES_CHARGING_DRIVERS.some((billingType) => hasBillingType(billingTypes, billingType))
